export default {
    departure: {
        title: 'Работа не ждет! Впереди много дел. С чего начнем?',
        button_1: {
            title: 'Вперед, в путешествие!',
            nextStep: false,
            answerText: 'txt1',
            isLose: true
        },
        button_2: {
            title: 'Проверить судно',
            nextStep: false,
        },
    },
    anchor: {
        title: 'Атомный ледокол снабжен двумя десятитонными Якорями Холла. Якорное устройство исправно, и мы сможем остановиться, когда это будет необходимо. Якорное устройство готово к работе?',
        button_1: {
            title: 'Да, я все проверил',
            nextStep: true,
        },
        button_2: {
            title: 'Уточнить работоспособность у электромехаников',
            nextStep: true,
        },
        nextQuest1: {
            title: 'Проверил, не сходя с места? Правильным решением будет дополнительная проверка.',
            button_1: {
                title: 'Продолжить',
                isLose: true,
            },
            nextStep: false,
        },
        nextQuest2: {
            title: 'Спасибо за бдительность, моряк! Электромеханики уже все подготовили.',
            button_1: {
                title: 'Продолжить',
                isLose: false,
            },
            nextStep: false,
        },
    },
    boat: {
        title: 'На ледоколе 14 плотов и 2 шлюпки: по 7 надувных плотов на бортах и 2 большие закрытые шлюпки на главной палубе. Все выглядят целыми. Интересно, а работают ли двигатели у шлюпок главной палубы?',
        button_1: {
            title: 'Обратиться к механикам ',
            nextStep: true,
        },
        button_2: {
            title: 'Оставить все как есть',
            nextStep: true,
            isLose: true,
        },
        button_3: {
            title: 'На всякий случай замотать изолентой',
            nextStep: true,
            isLose: true,
        },
        nextQuest1: {
            title: 'Двигатели работают исправно. Однако проверка никогда не бывает лишней. Спасибо за бдительность, моряк!',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest2: {
            title: 'Похоже, тебе не очень-то хочется работать, моряк...',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest3: {
            title: 'Вообще-то это не уместно, моряк. У нас и так все работает.',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
    },
    wheel: {
        title: 'Наш ледокол оснащён рулевым устройством с электрогидравлической рулевой машиной и двумя рулевыми насосами. Все системы исправны. Правда, на приборной панели мигает что-то красное. Может быть, что-то не так?',
        button_1: {
            title: 'Обратиться к механику',
            nextStep: true,
        },
        button_2: {
            title: 'Обратиться к штурману',
            nextStep: true,
        },
        button_3: {
            title: 'Не обращать внимание на приборную панель.',
            nextStep: true,
            isLose: true,
        },
        nextQuest1: {
            title: 'Спасибо за бдительность, моряк! Все в порядке, это нормальное рабочее состояние. ',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest2: {
            title: 'Спасибо за бдительность, моряк! Все в порядке, это нормальное рабочее состояние. ',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest3: {
            title: 'Зря ты так, моряк, лучше лишний раз уточнить.',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
    },
    find_boat: {
        title: 'Теперь наша задача, моряк, обнаружить застрявший во льдах корабль, чтобы точно скорректировать курс. Как будем искать?',
        button_1: {
            title: 'Использовать радар',
            nextStep: true,
        },
        button_2: {
            title: 'Использовать карту и GPS-трекер',
            nextStep: true,
        },
        button_3: {
            title: 'Осмотреться самому',
            nextStep: true,
            isLose: true,
        },
        nextQuest1: {
            title: 'Молодец, моряк! Надежный способ обнаружения судна.',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest2: {
            title: 'Мыслишь в правильном направлении, моряк. Так и поступим!',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
        nextQuest3: {
            title: 'Эх, моряк! 21 век, и наши приборы видят лучше даже самых зорких человеческих глаз. Зря пренебрегаешь технологиями.',
            button_1: {
                title: 'Продолжить',
            },
            nextStep: false,
        },
    },
};
